import { useFeature } from '@sendpayments/react-shared/hooks/useFeature';
import { PD_4823_REBRANDING_2025 } from '@sendpayments/shared-constants/features';

export const useRebrandValue = () => {
  const [
    {
      data: { isEnabled: isRebrandActive },
    },
  ] = useFeature({
    feature: PD_4823_REBRANDING_2025,
    activeValue: undefined,
    functionName: `Captcha`,
    defaultValue: undefined,
  });

  return isRebrandActive;
};

export const useRebrandConditionalValue = <T>(rebrandValue: T, defaultValue: T): T => {
  return useRebrandValue() ? rebrandValue : defaultValue;
};
